<template>
  <div class="tip-dot" :data-placement="placement"></div>
</template>

<script>
export default {
  props: {
    placement: {
      type: String,
      default: () => 'center'
    }
  }
}
</script>

<style lang="scss" scoped>
.tip-dot {
  position: absolute;
  width: get_vh(12px);
  height: get_vh(12px);
  background-color: #CA3939;
  border-radius: 50%;
  border: get_vh(1px) solid #fff;

  &[data-placement='nav'] {
    right: get_vh(8px);
    top: 50%;
    margin-top: get_vh(-6px);
  }
  &[data-placement='store'] {
    right: get_vh(3px);
    top: 50%;
    margin-top: get_vh(-6px);
  }

   &[data-placement='quizs'] {
    right: get_vh(30px);
    top: 50%;
    margin-top: get_vh(-6px);
  }
  &[data-placement='dedicate'] {
    right: get_vh(20px);
    top: 50%;
    margin-top: get_vh(-3px);
    // @media screen and (max-aspect-ratio: 3/ 2) {
    //   right: 2vw;
    // }
  }

   &[data-placement='mall'] {
    right: 27%;
    top: 50%;
    margin-top: get_vh(-3px);
  }
   &[data-placement='activity'] {
    right: 27%;
    top: 50%;
    margin-top: get_vh(-3px);
  }

  &[data-placement='liveDaily'] {
    // right: get_vh(24px);
    // top: get_vh(20px);
    width: get_vh(12px);
    height: get_vh(12px);
    top: 13%;
    right: 8%;
    // margin-top: get_vh(-6px);
  }



  &[data-placement='quiz'] {
    // right: get_vh(22px);
    // top: get_vh(20px);
    width: get_vh(12px);
    height: get_vh(12px);
    top: 13%;
    right: 8%;
    // margin-top: get_vh(-6px);
  }

  &[data-placement='price'] {
    width: get_vw(8px);
    height: get_vw(8px);
    right: 36%;
    top: 50%;
    margin-top: get_vw(-1px);
  }
 
  &[data-placement='cheer'] {
    width: get_vh(12px);
    height: get_vh(12px);
    top: 13%;
    right: 8%;
    // margin-top: get_vh(-6px);
  }

  // &[data-placement='btn'] {
  //   right: get_vh(26px);
  //   top: 50%;
  //   margin-top: get_vh(-6px);
  // }
  
  
 
  // &[data-placement='daily'] {
  //   // right: get_vh(24px);
  //   left: get_vh(180px);
  //   top: get_vh(15px);
  // }


  // &[data-placement='accrue'] {
  //   right: get_vh(24px);
  //   top: get_vh(15px);
  // }
  @media screen and (max-aspect-ratio: 3 / 2) {
    width: get_vw(12px);
    height: get_vw(12px);
  }
}
</style>